var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C8.9543 40 0 31.0456 0 20C0 8.9543 8.9543 0 20 0C31.0456 0 40 8.9543 40 20C40 31.0456 31.0456 40 20 40ZM17.2438 12.8292C17.1124 12.7416 16.958 12.6948 16.8 12.6948C16.3582 12.6948 16 13.053 16 13.4948V26.5052C16 26.6632 16.0468 26.8176 16.1344 26.949C16.3794 27.3166 16.8762 27.416 17.2438 27.1708L27.0016 20.6656C27.0894 20.607 27.1648 20.5316 27.2234 20.4438C27.4686 20.0762 27.3692 19.5794 27.0016 19.3344L17.2438 12.8292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideoBig);
export default __webpack_public_path__ + "static/media/play_video_big.ba7d467539a16c41d0b0cccb4a97ddb3.svg";
export { ForwardRef as ReactComponent };